import React, { useState, useEffect } from "react";
import api from '../../assets/constants/Rafservice.Instance';
import WidgetCard from "../../components/Cards/WidgetCard";
import SingleVerticalBarChart from '../../components/Charts/SingleVerticalBar.Chart';
import AcaYearSelect from '../../components/DropDowns/AcaYearSelect';
import { getAcaYearList, getAcaYear } from '../../assets/constants/yearList';
import ServerSideGridTable from "../../components/TableGrids/ServerSideGridTable.table";
import GridTable from "../../components/TableGrids/GridTable.table";
import { anchorTag, hccSeperator, numberWithCommas,anchorTagnumberWithCommas } from '../../assets/constants/customRender'
import history from "../../history";
import { MAO_Allowed_Disallowed_Period, MAO_Allowed_Disallowed_Type,MAO_Allowed_Disallowed_Year } from "../../assets/constants/string.constants";
import { percentFormat } from "../../assets/helpers/formats.helpers";
import CardComponent from "../../components/Cards/card";
import LockOpenIcon from '@material-ui/icons/LockOpen';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceTwoToneIcon from '@material-ui/icons/AccountBalanceTwoTone';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import BarChartIcon from '@material-ui/icons/BarChart';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import GChart from '../../components/GChart/GChart';
import IssuersACA from '../ACA/ACAIssuers.page';
import SlickSlider from '../../components/SlickSlider/SlickSlider';
import SubHeader from '../../components/home/header/subHeader';
import { getViewBySelect } from '../../assets/constants/viewByList';
import { getModelSelect } from '../../assets/constants/modelList';
import { getMetalTierSelect } from '../../assets/constants/metalTierList';
import { getPlanSelect } from '../../assets/constants/planList';
import { getModuleSelect } from '../../assets/constants/moduleList';
import { getMeInitialSelect} from '../../assets/constants/meInitialList';
import Link from '@material-ui/core/Link';
import { connect } from 'react-redux';
//import google from "react-google-charts";
const MaoAllowedDisallowedSummary = (props) => {

    const [PresentYearData, setPresentYearData] = useState([]);
    const [PastYearData, setPastYearData] = useState([]);
    
    const PastYearColumns = [
        {
            name: "rafYear",
            label: "Period"
        },
        {
            name: "validEncounters",
            label: "# Total Valid Encounters",
            options: numberWithCommas
        },
        {
            name: "claimallowedcount",
            label: "# Total Claim Allowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "claimdissallowedcount",
            label: "# Total Claim Disallowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "craddallowedcount",
            label: "# Total CR Allowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "cradddissallowedcount",
            label: "# Total CR Disallowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "disallowedRatio",
            label: "Disallowed %",
        },
        {
            name: "spacecount",
            label: "# Total CR Deletes",
            options: numberWithCommas
        }
    ]
   
    const PresentYearColumns = [
        {
            name: "rafPeriod",
            label: "PERIOD"
        },
        {
            name: "validEncounters",
            label: "# Total Valid Encounters",
            options: numberWithCommas
        },
        {
            name: "claimallowedcount",
            label: "# Total Claim Allowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "claimdissallowedcount",
            label: "# Total Claim Disallowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "craddallowedcount",
            label: "# Total CR Allowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "cradddissallowedcount",
            label: "# Total CR Disallowed",
            options: anchorTagnumberWithCommas
        },
        {
            name: "disallowedRatio",
            label: "Disallowed %",
        },
        {
            name: "spacecount",
            label: "# Total CR Deletes",
            options: numberWithCommas
        }
    ]


    const loadPresentYearEncounterSummary = () => {
        api.get('/AllowedDisallowedSummary/Maoyear/'+props.yearSelect+'/Maoper/undefined')
            .then(res => {
                setPresentYearData(res);
            })
            .catch(err => {
                // console.log(err)
            })
    }

    const loadPastYearEncounterSummary = () => {
        api.get('/AllowedDisallowedSummaryYears/Maoyear/'+props.yearSelect+'/Maoper/undefined')
            .then(res => {
                setPastYearData(res);
            })
            .catch(err => {
                // console.log(err)
            })
    }

    const PresentYearTableClick = (colData,cellMeta,data,columns) => {
        if ((cellMeta.colIndex === 2) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'CA');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/satistics_chart');
        }else if ((cellMeta.colIndex === 3) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'DCA');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/disallowed_summary');
        }else if ((cellMeta.colIndex === 4) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'CR');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/satistics_chart');
        }else if ((cellMeta.colIndex === 5) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'DCR');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/disallowed_summary');
        }
    }
  
    const PastYearTableClick = (colData,cellMeta,data,columns) => {
        if ((cellMeta.colIndex === 2) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'CA');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/satistics_chart');
        }else if ((cellMeta.colIndex === 3) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'DCA');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/disallowed_summary');
        }else if ((cellMeta.colIndex === 4) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'CR');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/satistics_chart');
        }else if ((cellMeta.colIndex === 5) && (colData.props.children != "")) {
            localStorage.setItem(MAO_Allowed_Disallowed_Type, 'DCR');
            localStorage.setItem(MAO_Allowed_Disallowed_Period, data[cellMeta.rowIndex].rafPeriod);
            localStorage.setItem(MAO_Allowed_Disallowed_Year, data[cellMeta.rowIndex].rafYear);
            history.push('/layout/medicare/disallowed_summary');
        }
    }

    useEffect(() => { 
        loadPresentYearEncounterSummary();      
        loadPastYearEncounterSummary();      
    },  [
        props.moduleSelect,
        props.viewBySelect,
        props.modelSelect,
        props.metalTierSelect,
        props.planSelect,
        getAcaYear(),
        getMeInitialSelect()
    ]);

    return (
        <div className="container level-summary">
            <div className="row">
                <div className="col-lg-12 pr-0 pl-0 mb-4">
                    <div className="state-level">
                        <div className="card-header">
                            <SubHeader title={'Allowed Disallowed Summary'} />
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 pr-0 pl-0">
                    <CardComponent
                        heading={`ALLOWED/DISALLOWED SUMMARY/LATEST YEAR - `+props.yearSelect}
                        body={
                            <div className="box-height-chart">
                                <GridTable
                                    data={PresentYearData}
                                    columns={PresentYearColumns}
                                    onTableClick={PresentYearTableClick}
                                ></GridTable>
                            </div>
                        }></CardComponent>
                </div>
                <div className="col-lg-12 pr-0 pl-0 mt-4">
                    <CardComponent
                        heading={`ALLOWED/DISALLOWED SUMMARY/PAST YEAR`}
                        body={
                            <div className="box-height-chart">
                                <GridTable
                                    data={PastYearData}
                                    columns={PastYearColumns}
                                    onTableClick={PastYearTableClick}
                                ></GridTable>
                            </div>
                        }></CardComponent>
                </div>

                <div className="col-lg-12 pr-0 pl-0 mt-5"></div>
                <br/>

                <br/>
                <br/> 

            </div>
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        moduleSelect: state.moduleFilter.moduleSelect,
        viewBySelect: state.moduleFilter.viewBySelect,
        modelSelect: state.moduleFilter.modelSelect,
        metalTierSelect: state.moduleFilter.metalTierSelect,
        planSelect: state.moduleFilter.planSelect,
        yearSelect: state.moduleFilter.yearSelect,        
        meInitialSelect: state.moduleFilter.meInitialSelect,
    };
  }
export default connect(mapStateToProps)(MaoAllowedDisallowedSummary);
